<template>
    <div class="slide">

        <go-back />

        <div class="slide-container">

            <div class="question">

                We are almost there, just a few more questions. Do you <span>save money</span> each month?

                <div class="description">
                    This includes IRA’s of your work Retirement Accts like 401(K)s or 403(b)s. Also include additional saving such as many you at to your investments accounts or banks.
                </div>

            </div>

            <div class="answer answer-col answers-centered">
                <span class="alternative" @click="next('yes')">Yes</span>
                <span class="alternative" @click="next('no')">No</span>
            </div>

        </div>

    </div>
</template>

<script>
import GoBack from "./GoBack";

export default {
    name: 'HaveSavings',
    components: {
        GoBack
    },
    methods: {
        next( haveOtherIncome ) {
            if ( haveOtherIncome === 'yes' ) {
                this.$router.push({ name: 'Savings' });
            } else {
                this.$router.push({ name: 'SectionThree' });
            }
        }
    }
}
</script>
